var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEspaceProgressionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "#FAF8F6"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 2.5,
    width: 30,
    height: 30,
    fill: "white",
    stroke: "#E6E6E7",
    strokeWidth: 0.5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(9.879 9.000) scale(0.5862)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 22.5734,
    cy: 15.9797,
    r: 1.97754,
    transform: "rotate(123.759 22.5734 15.9797)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.3222,
    cy: 2.79658,
    r: 1.97754,
    transform: "rotate(44.5607 15.3222 2.79658)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.42429,
    cy: 5.71868,
    r: 1.97754,
    transform: "rotate(15.0328 2.42429 5.71868)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.40724,
    cy: 18.5675,
    r: 1.97754,
    transform: "rotate(-55.8044 3.40724 18.5675)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.1602,
    cy: 26.3652,
    r: 1.97754,
    transform: "rotate(-154.586 15.1602 26.3652)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 3.57812,
    y: 6.47559,
    width: 9.89488,
    height: 0.709329,
    transform: "rotate(44.2109 3.57812 6.47559)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 15.4648,
    y: 4.12012,
    width: 9.89488,
    height: 0.832634,
    transform: "rotate(101.388 15.4648 4.12012)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.8477,
    y: 15.1543,
    width: 9.89488,
    height: 0.832634,
    transform: "rotate(80.2967 13.8477 15.1543)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.1445,
    y: 15.292,
    width: 9.89488,
    height: 0.832634,
    transform: "rotate(161.798 14.1445 15.292)",
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5264,
    cy: 14.5019,
    r: 3.29589,
    fill: "#0A0A0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21.6602,
    y: 16.7314,
    width: 9.89488,
    height: 0.832634,
    transform: "rotate(-171.831 21.6602 16.7314)",
    fill: "#0A0A0B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEspaceProgressionIcon);
export default __webpack_public_path__ + "static/media/espaceProgressionIcon.bbf2beede5a68e1cf9fd314abe3c334b.svg";
export { ForwardRef as ReactComponent };